/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Trello } from "../types/trello"
import { openLinkCustomerPopup } from "./popup"

export async function getCardButton(
  t: Trello.PowerUp.IFrame,
  props: any
): Promise<Trello.PowerUp.CardButton[]> {
  return [
    {
      icon: props.baseUrl + props.logo.light,
      text: "Link customer",
      callback: (t: Trello.PowerUp.IFrame) => openLinkCustomerPopup(t)
    }
  ]
}
